import { buildValue, makeDecimal } from './Utils/utils'

export const ChartOptions = (event, jsonConfig, theme = 'light', height, width) => {
    // const { group = [], events, attr, select = [] } = state || {}
    const tamPercent = width * 0.07
    const tam = tamPercent > 50 ? 50 : tamPercent

    const {
        value,
        valueColor,
        target,
        targetColor,
        title,
        unit,
        usingRange,
        extremeUnity,
        showDivider,
        gradient,
        stopsColor1,
        stopsColor2,
        stopsColor3,
        stopsValue1,
        stopsValue2,
        stopsValue3
    } = jsonConfig

    const data = [Number(buildValue(value, event)), parseInt(buildValue(target, event))] || [0, 0]
    const setStopColor = value => {
        if (value < parseInt(stopsValue1)) return stopsColor1
        else if (value < parseInt(stopsValue2)) return stopsColor2
        else if (value >= parseInt(stopsValue3) || value < parseInt(stopsValue3)) return stopsColor3
        else return valueColor
    }

    return {
        chart: {
            type: 'solidgauge',
            backgroundColor: theme === 'light' ? '#fff' : '#364159',
            zoomType: 'xy'
        },

        title: {
            text: title || '',
            style: {
                color: theme === 'light' ? '#212D44' : '#fff'
            }
        },

        pane: {
            center: ['50%', '80%'],
            size: '130%',
            startAngle: -90,
            endAngle: 90,
            background: {
                backgroundColor: targetColor || '#EEE',
                innerRadius: '60%',
                outerRadius: '100%',
                shape: 'arc'
            }
        },
        exporting: {
            enabled: false
        },
        tooltip: {
            enabled: false,
            valueSuffix: unit
        },

        yAxis: {
            min: 0,
            max: data[1] || 10,
            stops:
                usingRange && gradient
                    ? [
                          [makeDecimal(stopsValue1, target), stopsColor1],
                          [makeDecimal(stopsValue2, target), stopsColor2],
                          [makeDecimal(stopsValue3, target), stopsColor3]
                      ]
                    : null,
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickAmount: 2,
            labels: {
                y: 25,
                align: 'center',
                distance: -50,
                style: {
                    color: theme === 'light' ? '#212D44' : '#fff'
                },
                formatter: function(e) {
                    return `<span>
                    ${e.value} ${extremeUnity ? unit : ''}</span>`
                }
            },

            plotLines: showDivider
                ? [
                      {
                          zIndex: 5,
                          dashStyle: 'solid',
                          color: '#C8CCD4',
                          width: 2,
                          value: stopsValue1 //data[1] / 4
                      },
                      {
                          zIndex: 5,
                          dashStyle: 'solid',
                          color: '#C8CCD4',
                          width: 2,
                          value: stopsValue2 //(data[1] * 3) / 4
                      }
                  ]
                : []
        },
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    y: 5,
                    borderWidth: 0,
                    useHTML: true
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                data: [{ y: data[0], color: setStopColor(data[0]) }], //valueColor
                dataLabels: {
                    enabled: true,
                    borderWidth: 0,
                    verticalAlign: 'bottom',
                    // {y:.2f}
                    format:
                        '<div style="text-align:center">' +
                        `<span style="font-size:${tam}px; color:${theme === 'light' ? '#212D44' : '#fff'}">{y}</span>` +
                        `<span style="font-size:15px; opacity:0.4; color: ${
                            theme === 'light' ? '#212D44' : '#fff'
                        }">${unit}</span>` +
                        '</div>'
                }
            }
        ]
    }
}
